export const SAVED_SEARCH_CHANNEL_PREFIX = 'search:';
export const LEGACY_SAVED_SEARCH_CHANNEL_PREFIX = 'smart:';

// Sentinel channel ids for the two non-saved-search reader channels. The
// navbar compares against these to drive active states and the TLDR prompt
// editor gate, so every producer and consumer must import them rather than
// spell the strings.
export const TLDR_CHANNEL_ID = 'tldr';
export const FLAGGED_CHANNEL_ID = 'flagged';
export const NEW_SEARCH_CHANNEL_ID = 'new-search';

// For You is not a backend channel -- it has its own endpoint -- but the
// reader's list, keyboard navigation, and row styling are all keyed by a
// channel id, so it carries one.
export const FOR_YOU_CHANNEL_ID = 'for-you';

export function channelUrl(channelId: string): string {
  if (channelId.startsWith(SAVED_SEARCH_CHANNEL_PREFIX)) return `/search/${channelId.slice(SAVED_SEARCH_CHANNEL_PREFIX.length)}`;
  if (channelId.startsWith(LEGACY_SAVED_SEARCH_CHANNEL_PREFIX)) return `/search/${channelId.slice(LEGACY_SAVED_SEARCH_CHANNEL_PREFIX.length)}`;
  if (channelId === FLAGGED_CHANNEL_ID) return '/flagged';
  return '/tldr';
}

export function savedSearchChannelId(id: string): string {
  return `${SAVED_SEARCH_CHANNEL_PREFIX}${id}`;
}

export function savedSearchIdFromChannel(channelId: string): string | null {
  if (channelId.startsWith(SAVED_SEARCH_CHANNEL_PREFIX)) {
    return channelId.slice(SAVED_SEARCH_CHANNEL_PREFIX.length);
  }
  if (channelId.startsWith(LEGACY_SAVED_SEARCH_CHANNEL_PREFIX)) {
    return channelId.slice(LEGACY_SAVED_SEARCH_CHANNEL_PREFIX.length);
  }
  return null;
}
